// Estilos para el HTML de los documentos legales (generado desde el .docx con pandoc).
export const LEGAL_DOC_CLASSES = [
  'text-sm text-gray-300 leading-relaxed',
  '[&_h1]:text-white [&_h1]:text-base [&_h1]:font-semibold [&_h1]:mt-8 [&_h1]:mb-3',
  '[&_p]:my-2.5 [&_strong]:text-white [&_a]:text-[#c9a84c] [&_a]:underline',
  '[&_ul]:list-disc [&_ul]:pl-5 [&_ul]:my-2 [&_li_p]:my-1',
  '[&_table]:w-full [&_table]:my-4 [&_table]:text-xs [&_td]:border [&_th]:border [&_td]:border-white/10 [&_th]:border-white/10 [&_td]:px-3 [&_td]:py-2 [&_th]:px-3 [&_th]:py-2 [&_th]:text-left',
].join(' ');
